export const FETCH_TEAMS = "FETCH_TEAMS";
export const LOAD_TEAMS = "LOAD_TEAMS";
export const CREATE_TEAM = "CREATE_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
export const SET_CURRENT_TEAM = "SET_CURRENT_TEAM";

export const FETCH_TEAM_MEMBERS = "FETCH_TEAM_MEMBERS";
export const LOAD_TEAM_MEMBERS = "LOAD_TEAM_MEMBERS";
export const REMOVE_TEAM_MEMBER = "REMOVE_TEAM_MEMBER";

export const FETCH_TEAM_INVITES = "FETCH_TEAM_INVITES";
export const LOAD_TEAM_INVITES = "LOAD_TEAM_INVITES";
export const INVITE_TEAM_MEMBER = "INVITE_TEAM_MEMBER";
export const ACCEPT_TEAM_INVITE = "ACCEPT_TEAM_INVITE";

export const FETCH_TEAM_HOLIDAYS = "FETCH_TEAM_HOLIDAYS";
export const LOAD_TEAM_HOLIDAYS = "LOAD_TEAM_HOLIDAYS";

export const TEAMS_ERROR = "TEAMS_ERROR";
export const CLEAR_TEAMS_ERROR = "CLEAR_TEAMS_ERROR";
